<template>
  <section class="overflow-hidden relative">
    <div class="absolute inset-0">
      <nuxt-img
        class="object-cover object-left w-full h-full lg:object-right"
        width="1440"
        height="558"
        loading="eager"
        fetchpriority="high"
        format="webp"
        sizes="xs:100vw sm:100vw md:100vw lg:100vw xl:100vw"
        :src="backgroundImageSrc"
        :alt="backgroundImageAlt"
      />
      <div class="absolute inset-0 bg-black/10 lg:hidden" aria-hidden="true" />
    </div>

    <div class="flex relative z-10 flex-col gap-5 items-start px-4 py-12 mx-auto max-w-7xl md:py-28 lg:gap-5.5 lg:px-10 lg:py-25 xl:pl-34 xl:pr-10">
      <div class="px-4 py-1.5 rounded-sm bg-lifeboost-red">
        <p
          class="text-xs tracking-widest leading-5 text-center text-white uppercase font-ww-bold"
          v-html="badgeText"
        />
      </div>

      <h1
        class="max-w-2xl text-3xl text-black font-ww-bold !leading-none sm:text-4xl lg:text-53"
        v-html="headline"
      />

      <div class="flex flex-col gap-2.5 max-w-2xl text-neutral-600">
        <p
          class="text-lg italic leading-7 font-ww-regular sm:text-22"
          v-html="quote"
        />
        <p
          class="text-base font-ww-regular leading-30 sm:text-lg"
          v-html="attribution"
        />
      </div>
    </div>
  </section>
</template>

<script setup>
defineProps({
  backgroundImageSrc: {
    type: String,
    default: '/assets/images/mans-health-mask.jpg'
  },
  backgroundImageAlt: {
    type: String,
    default: 'Hand stacking health blocks'
  },
  badgeText: {
    type: String,
    default: "Men's Health Special Report"
  },
  headline: {
    type: String,
    default: 'The 6 Health Red Flags <span class="italic text-lifeboost-red">Every Man Over 40</span> Should Know About'
  },
  quote: {
    type: String,
    default: '“How one simple daily habit — combined with targeted strategies — helped me feel better at 48 than I did in my thirties.”'
  },
  attribution: {
    type: String,
    default: '<span class="italic font-bold font-ww-bold">- Dr. Charles</span> <span class="italic">- CEO &amp; Founder, Lifeboost Coffee</span>'
  }
})

defineBuilderComponent({
  friendlyName: 'Hero - Special Report',
  inputs: [
    {
      name: 'backgroundImageSrc',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
      defaultValue: '/assets/images/mans-health-mask.jpg'
    },
    {
      name: 'backgroundImageAlt',
      type: 'text',
      defaultValue: 'Hand stacking health blocks'
    },
    {
      name: 'badgeText',
      type: 'text',
      defaultValue: "Men's Health Special Report"
    },
    {
      name: 'headline',
      type: 'richText',
      defaultValue: 'The 6 Health Red Flags <span class="italic text-lifeboost-red">Every Man Over 40</span> Should Know About'
    },
    {
      name: 'quote',
      type: 'richText',
      defaultValue: '“How one simple daily habit — combined with targeted strategies — helped me feel better at 48 than I did in my thirties.”'
    },
    {
      name: 'attribution',
      type: 'richText',
      defaultValue: '<span class="italic font-bold font-ww-bold">- Dr. Charles</span> <span class="italic">- CEO &amp; Founder, Lifeboost Coffee</span>'
    }
  ]
})
</script>
